import styled from "styled-components";
import { StyledCellProps } from "./TableCell.types";

export const StyledCell = styled.td<StyledCellProps>`
	${({ theme, fontAttributes }) => ({
		position: "relative",
		padding: `${theme.space.lg} ${theme.space.xl}`,
		fontSize: fontAttributes[0],
		lineHeight: fontAttributes[1],
	})}
`;
